var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApEvcsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.9 -5.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.26,5.92H14.568A1.67,1.67,0,0,0,12.9,7.588V40.252a1.67,1.67,0,0,0,1.668,1.668H41.26a1.67,1.67,0,0,0,1.668-1.668V7.588A1.67,1.67,0,0,0,41.26,5.92Zm.9,34.332a.9.9,0,0,1-.9.9H14.568a.9.9,0,0,1-.9-.9V7.588a.9.9,0,0,1,.9-.9H41.26a.9.9,0,0,1,.9.9Z",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.676,9.8H17.593a.812.812,0,0,0-.813.813V41.668a.812.812,0,0,0,.813.813H42.672a.812.812,0,0,0,.813-.813V10.613a.812.812,0,0,0-.813-.813Zm.043,7.563H17.55V14.445H42.715v2.917Zm-25.165.77H29.69v5.625H17.55V18.133Zm12.97,0h12.2v5.625h-12.2V18.133ZM17.593,10.57H42.672a.04.04,0,0,1,.043.043v3.063H17.55V10.613A.04.04,0,0,1,17.593,10.57ZM42.672,41.711H17.593a.04.04,0,0,1-.043-.043V24.523H42.715V41.668a.04.04,0,0,1-.043.043Z",
    transform: "translate(-2.22 -2.22)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.668,57.81a2.378,2.378,0,1,0,2.378,2.378A2.381,2.381,0,0,0,44.668,57.81Zm0,3.982a1.608,1.608,0,1,1,1.608-1.608A1.612,1.612,0,0,1,44.668,61.792Z",
    transform: "translate(-16.818 -29.694)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.555,52.37a4.705,4.705,0,1,0,4.705,4.705A4.711,4.711,0,0,0,41.555,52.37Zm0,8.641a3.935,3.935,0,1,1,3.935-3.935A3.941,3.941,0,0,1,41.555,61.011Z",
    transform: "translate(-13.705 -26.581)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.049,57.917a.385.385,0,0,0-.5.586l1.929,1.651L26.45,61.891a.386.386,0,0,0-.043.543.379.379,0,0,0,.291.133.36.36,0,0,0,.248-.094l2.37-2.028a.385.385,0,0,0,0-.582l-2.271-1.946Z",
    transform: "translate(-7.677 -29.702)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.335,60.154,65.264,58.5a.385.385,0,0,0-.5-.586l-2.271,1.946a.385.385,0,0,0,0,.582l2.37,2.028a.375.375,0,0,0,.248.094.383.383,0,0,0,.248-.676l-2.028-1.737Z",
    transform: "translate(-28.303 -29.702)",
    stroke: "#000",
    strokeWidth: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApEvcsIcon);
export default __webpack_public_path__ + "static/media/ap-evcs-icon.784deda1584b0da83cd885b13a405dd3.svg";
export { ForwardRef as ReactComponent };